export const files = require.context("../assets/images", true, /\.(png|webp|jpe?g|svg)$/);

export const asset = (name) => {
  const requested = String(name || "").replace(/^\.\//, "");
  const candidates = [requested];
  if (/\.(png|jpe?g)$/i.test(requested)) {
    candidates.unshift(requested.replace(/\.(png|jpe?g)$/i, ".webp"));
  }
  for (const candidate of candidates) {
    try {
      return files(`./${candidate}`);
    } catch {
      // try the next extension
    }
  }
  throw new Error(`Cannot find module './${requested}'`);
};
